export default {
	assetLabel: 'Lisa vara seoseid',
	dataAssetLabel: 'Lisa infovara seoseid',
}
